/* Selected-SKU evidence only. Gallery and film DOM remain owned by their existing components. */
(() => {
  'use strict';
  const data = window.FultonsEthnicraftMediaData;
  if (!data) return;
  const option = (id, sku) => data.products[String(id)]?.options[String(sku)];
  const unique = values => [...new Set(values.filter(Boolean))];
  const claimed = (root, sku) => root._ethnicraftMediaClaimedSku === String(sku);
  const claim = (root, sku) => {
    if (root._ethnicraftMediaSelection?.sku !== String(sku)) return false;
    root._ethnicraftMediaClaimedSku = String(sku);
    return true;
  };
  const publish = (root, id, sku, owner) => {
    const record = option(id, sku);
    if (!record) { root._ethnicraftMediaSelection = null; root._ethnicraftMediaClaimedSku = null; return false; }
    if (root._ethnicraftMediaSelection?.productId === String(id) && root._ethnicraftMediaSelection?.sku === String(sku)) return claimed(root, sku);
    const detail = {
      version: 1, productId: String(id), sku: String(sku), owner,
      exactPhotoIds: unique(record.exactPhotoIds), referencePhotoIds: unique(record.referencePhotoIds),
      photoIds: unique([record.displayHeroPhotoId || record.exactHeroPhotoId, ...record.exactPhotoIds, ...record.referencePhotoIds]),
      displayHeroPhotoId: record.displayHeroPhotoId || record.exactHeroPhotoId || record.referencePhotoIds[0] || null,
      exactHeroPhotoId: record.exactHeroPhotoId || null,
      referenceWarning: record.referenceWarning || null,
      exactVideoIds: unique(record.exactVideoIds || [])
    };
    root._ethnicraftMediaSelection = detail;
    root._ethnicraftMediaClaimedSku = null;
    const event = new CustomEvent('fultons:ethnicraft-media-selection', {detail, bubbles: true, cancelable: true});
    if (!root.dispatchEvent(event)) claim(root, sku);
    return claimed(root, sku);
  };
  // Resolve photo URLs from the existing gallery's reviewed records, never a second photo catalogue.
  const photo = (root, photoId) => {
    if (!photoId) return null;
    const gallery = root.querySelector('fultons-product-gallery');
    let records = gallery?.reviewed;
    if (!Array.isArray(records)) { try { records = JSON.parse(gallery?.querySelector('[data-reviewed-gallery]')?.textContent || '[]'); } catch { records = []; } }
    return records.find(record => record.id === photoId && record.src) || null;
  };
  const choice = (root, id, sku, item, showGuide = false) => {
    const record = option(id, sku);
    if (!record) return item;
    const result = {...item};
    if (Object.hasOwn(item, 'fallbackPhoto')) result.image = item.fallbackPhoto;
    const thumbnail = photo(root, record.displayThumbnailPhotoId || record.thumbnailPhotoId);
    const exact = thumbnail && record.exactPhotoIds.includes(thumbnail.id);
    const reference = record.referencePhotoIds.map(photoId => photo(root, photoId)).find(Boolean);
    const selected = thumbnail || reference;
    if (selected) {
      result.image = selected.sources?.find(source => source.width >= 160)?.src || selected.src; result.photoId = selected.id;
      result.imageNote = exact ? '' : 'Reference photo';
      result.photoFrame = exact ? record.photoFrame || null : null;
    } else if (result.image) result.imageNote = 'Reference image';
    else result.imageNote = 'Exact photo unavailable';
    if (showGuide && record.guideAsset && window.FultonsEthnicraftGuideAssets?.[record.guideAsset]) {
      result.sizeGuide = {src: window.FultonsEthnicraftGuideAssets[record.guideAsset], label: record.guideLabel};
    }
    return result;
  };
  window.FultonsEthnicraftMedia = {option, choice, publish, claim, claimed, guideOnFinish: id => data.products[String(id)]?.guideOnFinish === true};
})();
